<template>
	<div class="dropdown dropright" style="max-width:500px;float:right" ref = "filterPopup" v-bind:class = "isTopPadding ? 'add-padding': ''">
		<div v-on:click="showFilters(true)" data-toggle="dropdown">
			<div v-if="filter" style = "width:12px;height:12px;border-radius:6px;right:-7px;top:1px;background-color:red;position:absolute">
			</div
			><i
			id="menu1"
			class="fas fa-ellipsis-v"
			aria-hidden="true"
			style="color:#333333"
		></i>

		</div>

		<div
			v-show="showFilter"
			class="dropdown-menu adv_filter"
			role="menu"
			aria-labelledby="menu1"
			style="min-width:550px !important;padding-bottom:0px"
		>
			<div>
				<button
					class="btn head_clear"
					@click="removeAllFilters()"
					v-on:click="preventToggle($event)"
				>
					<span class="text">Clear</span>
				</button>
				<p style="float: left;margin: 20px 0px 0px 80px;auto;color:#333">
					<font size="4">
						<b>Advance Filters</b>
					</font>
				</p>
					<!-- <i class="close fa fa-times col-md-3" style="margin:auto" v-on:click="removeAllFilters(true)"></i> -->
				<!-- <div class="col-md-4"></div> -->
			</div>
			<div style="overflow-x:hidden;overflow-y:scroll;max-height:500px;width:100%">
				<form v-on:click="preventToggle($event)">
					<div
						v-for="(filter,index) in filters"
						:key="index"
						style="padding:10px;border-bottom:1px solid #ddd;margin-left:15px;margin-right:15px;padding-top:10px"
						:style="filter.type != 'break'? 'background:#fafafa':'background:white'"
					>
						<template v-if="filter.type != 'break'" >
							<div class="row" :style="isPadding?'margin-bottom:30px':''">
								<div class="col-md-12 row" style="padding-right:0px;padding-left:26px !important">
									<span
										class="span-label col-md-3 text-xs-center"
										style="margin-left:4px;padding:0px !important;margin-top:3px;color:#333 !important"
									>{{filter.label}}</span>
									<toggle-button
										class="col-md-1"
										style="padding:0px !important;margin-top:3px"
										v-if="!filter.readonly"
										v-model="filter.enabled"
										@change="toggle(filter)"
										:sync="true"
										color="#115e67"
									/>
									<div class="col-md-1"></div>
									<div
										class="col-md-6"
										v-if="filter.enabled"
										style="padding:0px !important"
									>
										<hierarchyFilter v-if="filter.subHierarchy" :filter="filter" @swap="toggle"/>
										<filterInput v-else :filter="filter" @fetchDynamicList="fetchDynamicList"/>
									</div>
								</div>
							</div>
						</template>
					</div>
				</form>
			</div>

				<div class="row"  style="margin-left:0px;background-color:#f6f6f6 !important;max-width:100%">
					<!-- <div class="dropdown-divider col-md-8"></div> -->
					<div style="margin-left:10px;margin-top:15px;margin-bottom:8px">
						<button
							class="btn"
							style="min-width:10px;"
							v-on:click="cancelFilters()"
						>Cancel</button>
						<button
							class="btn apply"
							style="min-width:10px;"
							@click="applyFilter('true')"
						><span class="text">Apply</span></button>
					</div>
				</div>
		</div>
	</div>
</template>
<script>
	import filterInput from "./filterInput";
	import hierarchyFilter from "./hierarchyFilter";
	export default {
		components: {
			filterInput,
			hierarchyFilter
		},
		props: {
			calledFrom:{
				type: String,
				 required: false
			},
			value: {
				type: Array,
				default: () => [],
				required: true
			},
			isPadding: {
				type: Boolean,
				required: false
			},
			isTopPadding:{
				type:Boolean,
				required:false
			}
		},
		watch: {
			copyFilter(){
			}
		},

		computed: {
			// keywordsFilter:{
			// 	set(val){
			// 		this.$store.commit('updateKeywordsFilter',val)
			// 	},
			// 	get(){
			// 		return this.$store.state.keywordsFilter
			// 	}
			// },
			automationFilter:{
				set(val){
					this.$store.commit('updateAutomationFilter',val)
				},
				get(){
					return this.$store.state.automationFilter
				}
			},
			productAdvanceFilter:{
				set(val){
					this.$store.commit('updateProductsFilter',val)
				},
				get(){
					return this.$store.state.productAdvanceFilter
				}
			},
			accountsFilter:{
				set(val){
					this.$store.commit('updateAccountsFilter',val)
				},
				get(){
					return this.$store.state.accountsFilter
				}
			},
			campaignsFilter:{
				set(val){
					this.$store.commit('updateCampaignsFilter',val)
				},
				get(){
					return this.$store.state.campaignsFilter
				}
			},
			vendorsList:{
				set(val) {
					this.$store.commit("updateVendorList", val);
				},
				get() {
				return this.$store.state.vendorList;
				}
			},

			filters() {
				return this.value.filter(filter =>
					filter.hasOwnProperty("remove") ? filter.remove : true
				);
			},
			countFilters() {
				return this.value.filter(filter =>
					filter.hasOwnProperty("show")
						? filter.show && filter.enabled
						: filter.enabled && this.hasValue(filter.value)
				);
			},
			enabledFilters() {
				return this.value.filter(filter => this.isEnabled(filter));
			},
			appliedFilters() {
				return this.value.filter(filter =>
					filter.hasOwnProperty("applied") ? filter.applied : false
				);
			}
		},
		mounted() {
		},
		methods: {
			fetchDynamicList(search) {
				const vm = this;
				var obj = {
					str: search
				};
				this.$store.dispatch("getAllVendor", obj).then(res => {
					//vm.vendorsList = res ? res : [];
					for(var i=0;i<vm.filters.length;i++){
						if(vm.filters[i].label == "Vendor" ){
							vm.filters[i].values = res ? res : []
						}
					}

				});
			},
			showFilters(data) {
				this.showFilter = data;
			},
			preventToggle(e) {
				if (e.currentTarget.classList[0] != "close") {
					$(".dropdown-menu").click(function(e) {
						e.stopPropagation();
					});
				}
			},
			// doToggle(e){
			//     $("i.close").click(function() {
			//     $("#dropDown").dropdown("toggle");
			//     });
			// },
			cancelFilters(){
					this.showFilter = false;
					this.$refs.filterPopup.click();
					if(this.filter){
						this.$emit('retainValues', this.copyFilter)
					}
					else{
						for (let filter of this.value) this.disableFilter(filter);
					}
					// if(this.$store.state.campaign.appliedFilters.length == 0){
					//    for (let filter of this.value) this.disableFilter(filter);
					// }

			},

			removeAllFilters(closeFilter, type) {
				//check if it being called from campaignlist page and currently untagged in true, then set the untagged as false
				if(this.$route.name=='campaignList' && this.$store.state.campaign.getUntagged){
					console.log('Setting the Untagged setting to be false')
					this.$store.state.campaign.getUntagged = false;
				}
				for (let filter of this.value) this.disableFilter(filter);
				this.showFilter = false;
				this.applyFilter('true');
				this.$store.commit('campaign/setAppliedFilers', [])

				this.$refs.filterPopup.click()
				// if(type == 'fromCancel'){
				// 	// this.selectedFilters.map((res) => {
				// 	// 	this.value.push({
				// 	// 		enabled : true
				// 	// 	})
				// 	// })
				// 	this.$emit('retainValues', this.$store.state.campaign.appliedFilters)
				// }
			},
			toggle(filter) {
				// debugger
				// if(filter.name=="untagged"&& filter.enabled){
				// 	debugger
				// 	this.filters.forEach(item=>{
				// 		if(item.name=="brand_tag" || item.name=="strategy_tag" || item.name=="country_tag" || item.name=="segment_tag"){
				// 			debugger
				// 			this.disableFilter(item)
				// 		}
				// 	})
				// }
				if (!filter.enabled) this.disableFilter(filter);
			},
			reset(closeFilter) {
				if (closeFilter) {
					this.showFilter = false;
				}

				let vm = this;
				this.value.forEach(filter => {
					if (!filter.applied && !filter.readonly) {
						filter.enabled = false;
						if (filter.type == "date") {
							filter.value = ["", ""];
						} else if (filter.type == "select_value") {
							filter.value = [];
						} else {
							filter.value = null;
						}
						filter.condition = filter.showCondition
							? null
							: filter.condition;
						if (filter.defaultValue) {
							filter.value = filter.defaultValue;
						}
					} else if (
						filter.readonly &&
						!(typeof filter.value === "object"
							? filter.value.length
							: filter.value)
					) {
						if (filter.defaultValue) {
							filter.value = filter.defaultValue;
						}
					} else if (filter.applied && !filter.enabled) {
						let lastFilter = vm.lastAppliedFilter.find(
							item => filter.name == item.name
						);
						if (lastFilter) {
							filter.condition = lastFilter.condition;
							filter.value = lastFilter.value;
							filter.enabled = true;
						}
					} else {
						//will do removal filters logic later.
						//  let lastFilter = vm.lastAppliedFilter.find(
						//     item => filter.name == item.name);
					}
				});

			},
			close() {
				if (!this.showConfirm) this.reset();
				else if (this.confirmClose()) this.reset();
			},
			applyFilter(data) {
				console.log(this.filters);
				if(!(this.calledFrom &&  this.calledFrom=='keywords')){
					this.$store.commit('campaign/setAppliedFilers', this.filters)
					this.accountsFilter = JSON.parse(JSON.stringify(this.filters))
					this.campaignsFilter = JSON.parse(JSON.stringify(this.filters))
					this.productAdvanceFilter = JSON.parse(JSON.stringify(this.filters))
					// this.keywordsFilter = JSON.parse(JSON.stringify(this.filters))
					this.automationFilter = JSON.parse(JSON.stringify(this.filters))
				}
				let response = [];
				this.lastAppliedFilter = [];
				this.copyFilter = JSON.parse(JSON.stringify(this.filters))
				for (let data of this.filters) {
					if (this.isEnabled(data)) {
						if (Array.isArray(data.name)) {
							data.name.forEach(function(name) {
								response.push({
									name: name,
									value: data.value,
									condition: data.condition,
									subValue: data.subHierarchy.value
								});
							});
						} else {
							response.push({
								condition: data.condition,
								name: data.subHierarchy
									? [
											{ name: data.name },
											{ subName: data.subHierarchy.name }
									  ]
									: data.name,
								value: data.subHierarchy
									? [
											{ value: data.value },
											{ subValue: data.subHierarchy.value }
									  ]
									: data.value
							});
						}
					} else {
						data.enabled = false;
						data.condition = data.showCondition ? null : data.condition;
					}
					if (!data.readonly) {
						//add applied flag if its not readonly
						let filterIndex = this.value.findIndex(
							filter => filter.name == data.name
						);
						data.applied = data.enabled;
						this.filters.splice(filterIndex, 1, data);
						if (data.applied)
							this.lastAppliedFilter.push(
								JSON.parse(JSON.stringify(data))
							); //save last applied filter
					}
				}
				if (data == "true") {
					this.showFilter = false;
					this.filter = response.length>0?true:false
					this.$emit("apply", response);
				}
				if(data){
					this.$refs.filterPopup.click()
				}
			},
			isEnabled(filter) {
				//enabled only if toggle is on & has value
				return filter.enabled && this.hasValue(filter.value);
			},
			confirmClose() {
				let notAppliedFilters = this.value.filter(
					filter =>
						(!filter.applied && this.isEnabled(filter)) ||
						(filter.applied && !this.isEnabled(filter))
				);
				let labels = notAppliedFilters.map(a => a.label).join(", ");

				if (notAppliedFilters.length > 0) {
					this.confirm.show = true;
					this.confirm.body =
						"You have unapplied filter(s) for " +
						labels +
						". Are you sure you want to close?";
					return false;
				} else return true;
			},
			hasValue(value) {
				return (
					typeof value != "undefined" &&
					(value != "" || typeof value == "boolean") &&
					value != null
				);
			},
			disableFilter(filter) {
				if (!filter.readonly) {
					if (filter.type == "date") {
						filter.value = ["", ""];
					} else if (filter.type == "select_value") {
						filter.value = [];
					} else {
						filter.value = null;
					}
					if (filter.subHierarchy) {
						filter.subHierarchy.enabled = false;
						filter.subHierarchy.value = null;
					}
					if (filter.hasOwnProperty("fields")) filter.name = null;
					if (!filter.conditionReadonly && filter.showCondition)
						filter.condition = null;
					filter.enabled = false;
				}
				if (filter.defaultValue) filter.value = filter.defaultValue;
				if (filter.subHierarchy && filter.subHierarchy.defaultValue)
					filter.subHierarchy.value = filter.subHierarchy.defaultValue;
			},
			setFilterActive(){
				this.filter = true
			}
		},
		data() {
			return {
				showConfirm: true,
				showFilter: true,
				lastAppliedFilter: [],
				confirm: {
					show: false,
					title: "Heads Up!"
				},
				filter:false,
				copyFilter:[]
			};
		}
	};
</script>

<style lang="scss">
.span-label,
.bold-label .v-label {
	font-weight: bolder;
	font-size: 14px;
	color: $tert-blue !important;
}
.add-padding{
	padding-top: 10px
}
#menu1{
	cursor: pointer;
}
.adv_filter{
	.multiselect.form-control{
		box-sizing: border-box;
		height: 43px;
		width:220px;
		border: 1px solid #979797;
		border-radius: 6px;
		background-color: #FFFFFF;
		.multiselect__content-wrapper{
			.multiselect__content{
				.multiselect__element{
					.multiselect__option--highlight{
						background:#115E67 !important;
					}
					.multiselect__option--highlight::after{
						background:#115E67 !important;
					}
				}
			}
			
		}
		
	}
	.apply{
		height: 38px;
		width: 105px;
		border-radius: 21.5px;
		background-color: #FFBF3F;
		.text{
			height: 19px;
			width: 106px;
			color: #333333;
			font-family: "Nunito Sans";
			font-size: 14px;
			font-weight: bold;
			letter-spacing: -0.03px;
			line-height: 19px;
			text-align: center;
		}
	}
	.head_clear{
		height: 38px;
		width: 105px;
		border-radius: 21.5px;
		background-color: #fafafa;
		float: left;
		margin:15px 10px 0px 15px;
		.text{
			height: 19px;
			width: 106px;
			color: #333333;
			font-family: "Nunito Sans";
			font-size: 14px;
			font-weight: bold;
			letter-spacing: -0.03px;
			line-height: 19px;
			text-align: center;
		}
	}

}
</style>
